<template>
  <div class="card mb-4">
    <div class="container">
      <div class="card-header pb-0">
        <h6>Edit</h6>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <form @submit.prevent="addLocation">
          <div class="form-group">
            <label for="locationName">Location Name</label>
            <input v-model="newLocation.name" type="text" class="form-control" id="locationName" required />
          </div>
          <div class="form-group">
            <label for="locationSearch">Search Location</label>
            <input v-model="searchLocation" ref="searchLocationInput" type="text" class="form-control" id="locationSearch" placeholder="Search for a location" style="width: 50%;"/>
            <div id="map" style="height: 400px;"></div>
          </div>
          <button type="submit" class="btn btn-primary mt-3" style="background-color: #141727; color: white; border: 2px solid #141727;">Add Location</button>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import AreaDataService from "../../services/AreaDataService.js";

export default {
  data() {
    return {
      areaId: null,
      newLocation: {
        name: '',
        area: []
      },
      map: null,
      polygon: null
    };
  },
  mounted() {
    this.initializeAutocomplete();
  },
  created() {
    this.areaId = this.$route.params.id;
    this.getAllArea(this.areaId);
  },
  methods: {
    getAllArea(areaId) {
      AreaDataService.get(areaId)
        .then(response => {
          this.newLocation = response.data.area;
          this.newLocation.area = response.data.area.area.coordinates[0].map(coord => ({
            lat: coord[1],
            lng: coord[0]
          }));
          this.initializeMap();
        })
        .catch(e => {
          console.log(e);
        });
    },
    initializeMap() {
      const mapOptions = {
        zoom: 12,
        center: this.newLocation.area.length > 0
          ? this.newLocation.area[0]
          : { lat: 18.5204, lng: 73.8567 }
      };

      this.map = new google.maps.Map(document.getElementById("map"), mapOptions);

      this.drawPolygon();

      const drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ['polygon']
        },
        polygonOptions: {
          editable: true
        }
      });
      drawingManager.setMap(this.map);

      google.maps.event.addListener(drawingManager, 'overlaycomplete', (event) => {
        if (event.type === google.maps.drawing.OverlayType.POLYGON) {
          if (this.polygon) {
            this.polygon.setMap(null);
          }
          this.polygon = event.overlay;
          this.newLocation.area = this.polygon.getPath().getArray().map(coord => ({ lat: coord.lat(), lng: coord.lng() }));
          this.addPolygonListeners(this.polygon);
        }
      });
    },
    initializeAutocomplete() {
      const input = this.$refs.searchLocationInput;
      this.autocomplete = new google.maps.places.Autocomplete(input);
      this.autocomplete.addListener('place_changed', this.searchAndMoveMarker);
    },
    searchAndMoveMarker() {
      const place = this.autocomplete.getPlace();
      if (place.geometry) {
        this.map.setCenter(place.geometry.location);
        this.map.setZoom(15);
        if (this.marker) {
          this.marker.setMap(null);
        }
        this.marker = new google.maps.Marker({
          map: this.map,
          position: place.geometry.location,
          draggable: true
        });

        this.newLocation.area = [{ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }];

        google.maps.event.addListener(this.marker, 'dragend', () => {
          const position = this.marker.getPosition();
          this.newLocation.area = [{ lat: position.lat(), lng: position.lng() }];
        });
      } else {
        alert("No details available for input: '" + place.name + "'");
      }
    },
    drawPolygon() {
      if (this.polygon) {
        this.polygon.setMap(null);
      }

      if (this.newLocation.area.length > 0) {
        this.polygon = new google.maps.Polygon({
          paths: this.newLocation.area,
          strokeColor: "#000000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#000000",
          fillOpacity: 0.35,
          editable: true
        });

        this.polygon.setMap(this.map);
        this.addPolygonListeners(this.polygon);

        const bounds = new google.maps.LatLngBounds();
        this.newLocation.area.forEach(point => bounds.extend(point));
        this.map.fitBounds(bounds);
      }
    },
    addPolygonListeners(polygon) {
      google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
        this.updatePolygonCoords();
      });
      google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
        this.updatePolygonCoords();
      });
    },
    updatePolygonCoords() {
      this.newLocation.area = this.polygon.getPath().getArray().map(coord => ({ lat: coord.lat(), lng: coord.lng() }));
    },
    addLocation() {
  // Ensure the first and last points are the same to form a closed polygon
  let transformedArea = this.newLocation.area.map(point => [point.lng, point.lat]);

  // Check if the polygon is closed; if not, close it
  if (transformedArea.length > 0 && (transformedArea[0][0] !== transformedArea[transformedArea.length - 1][0] ||
    transformedArea[0][1] !== transformedArea[transformedArea.length - 1][1])) {
    transformedArea.push(transformedArea[0]);
  }

  const payload = {
    id: this.newLocation.id,
    name: this.newLocation.name,
    area: {
      type: "Polygon",
      coordinates: [transformedArea]
    }
  };

  AreaDataService.update(payload)
    .then(response => {
      console.log(response);
      this.$router.push({ name: 'Area' });
    })
    .catch(e => {
      console.log(e);
    });
}

  }
};
</script>
<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #82d616;
}

input:focus + .slider {
  box-shadow: 0 0 1px #82d616;
}

input:checked + .slider:before {
  transform: translateX(14px);
}
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.table {
  width: 100%;
  margin-top: 20px;
}
.table .btn {
  margin-right: 5px;
}
</style>
